import Column from '@components/Column';
import styled from '@emotion/styled';
import { ShopInMapRow } from '@models/shop';

import ShopMap from './ShopMap';
import ShopList from '../ShopList';
import useShopsInMap from './hooks/useShopsInMap';

interface Props {
    isOrder?: boolean;
    originalItemId?: string;
    shops?: ShopInMapRow[];
    isLoading?: boolean;
    fetchNext?: ()=> void;
}

function MapAndList({
    isOrder, originalItemId, shops, isLoading, fetchNext,
}:Props) {
    const { markers } = useShopsInMap({
        originalItemId, isOrder,
    });
    return (
        <Column fullWidth fullHeight>
            <MapContainer>
                <ShopMap markers={markers}
                    shops={shops}
                    isOrder={!!isOrder} />
            </MapContainer>
            <ListContainer>
                <ShopList isOrder={!!isOrder}
                    originalItemId={originalItemId}
                    shops={shops}
                    isBlank={shops?.length === 0}
                    isLoading={isLoading}
                    fetchNext={fetchNext}
                    fit />
            </ListContainer>
        </Column>
    );
}

const MapContainer = styled.div`
    width: 100%;
`;

const ListContainer = styled.div`
    padding-top: var(--spacing-4);
    width: 100%;
`;

export default MapAndList;
